import clsx from "clsx";
import Input, { InputProps } from "./Input";
import Label from "./Label";
import LabelInputStyle from "./css/LabelInput.module.css";
import { forwardRef, ReactNode } from "react";
import Text from "./Text";

type LabelInputProps = InputProps & {
    label?: ReactNode;
    input?: ReactNode;
    id?: string;
    required?: boolean;
    direction?: "top" | "left";
}

const LabelInput = forwardRef<HTMLInputElement, LabelInputProps>(
    ({ label, input, id, direction = "top", required = false, style, readOnly, fullWidth, ...props }: LabelInputProps, ref) => {
        const _label = label ?? <Text size={direction === "top" ? "sm" : "md"}>라벨</Text>;
        return (
            <div
                className={clsx(
                    LabelInputStyle["label-input-container"],
                    LabelInputStyle[`label-input-container-${direction}`]
                )}
                style={{
                    width: fullWidth ? "100%" : undefined,
                }}
            >
                <Label required={required} htmlFor={id}>{_label}</Label>
                <Input
                    id={id}
                    style={{
                        backgroundColor: readOnly ? "#F5F7F9" : "#FFFFFF",
                        ...style
                    }}
                    readOnly={readOnly}
                    fullWidth={fullWidth}
                    ref={ref}
                    {...props}
                />
            </div>
        );
    }
);

export default LabelInput;